import React from 'react';
import { ShowWhatYouKnow } from 'abbot-core';
import img from '../../assets/images/U1-T2-4-1.svg';
import voAudio from '../../assets/vo/U1-T2-4-1.mp3';

const vo = {
  src: voAudio,
};

const topic = 'making the most nutritious food choices possible';


export default {
  title: 'Show What You Learned',
  path: '/challenge/show-what-you-learned',
  content: (
    <ShowWhatYouKnow
      vo={vo}
      topic={topic}
      image={img}
    />
  )
};



// WEBPACK FOOTER //
// ./src/data/challenge/ShowWhatYouLearned.js